function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Menu } from 'native-base';
import { MENU_POSITION } from '../../../Constants';
const FRNMenu = props => {
  return /*#__PURE__*/React.createElement(Menu, _extends({
    _overlay: {
      style: {
        position: 'fixed'
      }
    },
    placement: MENU_POSITION
  }, props), props.children);
};
export default FRNMenu;
//# sourceMappingURL=FRNMenu.js.map